export class ServerSideError extends Error {
    
    constructor() {
        super();
    }
}